//@flow
import React from 'react';
import {
  Notifier,
}
from 'lib/notifier';
import {
  Link
} from 'react-router-dom';
import ProfilePicture from 'lib/profile-picture';
import css from './info-bar.css';

type Props = {
  location: Object,
  data: Object
}

class InfoBar extends React.Component < Props > {
  render() {
    const style = null;
    const user = this.props.data.user ? this.props.data.user : null;
    if (!user) return null;

    const dev = process.env.NODE_ENV === 'development' ?
      "DEV" :
      null;

    const admin = user.isAdmin ?
      "ADMIN" :
      null;

    return <div className={css.infobar} style={style}>
      <div className={css.title}>
        {dev}&nbsp;{admin}&nbsp;<Notifier/>
      </div>
      {/* <div className={css.content}></div> */}
      <div className={css.user}>
        <Link to={`/directr/person/${this.props.data.user.person.id}`}>
        {/* {this.props.data.user.person.email} */}
          </Link>
          </div>

        <div className={css.profilePicture}>
          <Link to={`/directr/person/${this.props.data.user.person.id}`}>
        <ProfilePicture person={this.props.data.user.person}/>
        </Link>
      </div>

    </div>

  }
}

export default InfoBar;